import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  inject,
  OnChanges,
  signal,
  Signal,
  ViewEncapsulation,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { injectViewContext } from '@ngneat/overview';

interface Context {
  severity: 'info' | 'warning' | 'alert';
  content: string;
}

@Component({
  selector: 'fz-announcement-banner',
  standalone: true,
  imports: [MatIconButton, MatIconModule],
  templateUrl: './announcement-banner.component.html',
  styleUrl: './announcement-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'fz-announcement-banner',
    '[class.fz-announcement-banner--alert]': 'context().severity === "alert"',
    '[class.fz-announcement-banner--warning]':
      'context().severity === "warning"',
    role: 'region',
    'aria-label': 'Announcement Banner',
  },
})
export class AnnouncementBannerComponent implements AfterViewInit, OnChanges {
  #elementRef = inject(ElementRef<HTMLElement>);

  context: Signal<Context> = injectViewContext<Context>();
  opened: boolean = true;
  height = signal<number>(0);

  ngAfterViewInit() {
    setTimeout(() => {
      this.updateHeight();
      document.body
        .querySelector('mat-toolbar.permanent')
        ?.classList.add('mat-toolbar--announcement-banner-offset');
    }, 1000);
  }

  ngOnChanges() {
    this.updateHeight();
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updateHeight();
  }

  updateHeight() {
    this.height.set(this.#elementRef.nativeElement.offsetHeight);
    document.body.style.setProperty(
      '--fz-announcement-banner-height',
      `${this.height()}px`,
    );
  }

  /**
   * Remove element from the DOM and reset the height variable.
   * This is called when the close button is clicked.
   */
  close() {
    this.#elementRef.nativeElement.remove();
  }
}
